var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.loading
    ? _c("bulk-request-modal-loader")
    : _c(
        "div",
        { staticClass: "request-documents-container py-2 overflow-auto h-100" },
        [
          _c("p", [
            _vm._v(_vm._s(_vm.$t("request-package.requestDocuments.subtitle"))),
          ]),
          _vm._v(" "),
          _vm.documentsClassifications.length
            ? _c("v-client-table", {
                staticClass: "vue-custom-table no-pagination",
                attrs: {
                  data: _vm.documentsClassifications,
                  columns: _vm.table.columns,
                  options: _vm.table.options,
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "h__selected",
                      fn: function () {
                        return [
                          _c("div", { staticClass: "form-group-checkbox" }, [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "pretty p-icon p-jelly p-smooth p-curve mr-0",
                              },
                              [
                                _c("input", {
                                  ref: "selectAll",
                                  staticClass: "checkbox",
                                  attrs: { id: "select-all", type: "checkbox" },
                                  domProps: { checked: _vm.allDocumentsMarked },
                                  on: {
                                    click: _vm.handleSelectAllClassifications,
                                  },
                                }),
                                _vm._v(" "),
                                _c("div", { staticClass: "state p-success" }, [
                                  _c("i", { staticClass: "icon fa fa-check" }),
                                  _vm._v(" "),
                                  _c(
                                    "label",
                                    {
                                      staticClass:
                                        "text-light-gray hidden-text",
                                      attrs: { for: "select-all" },
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t("global.actions.selectAll")
                                        )
                                      ),
                                    ]
                                  ),
                                ]),
                              ]
                            ),
                          ]),
                        ]
                      },
                      proxy: true,
                    },
                    {
                      key: "selected",
                      fn: function (ref) {
                        var row = ref.row
                        return [
                          _c("div", { staticClass: "form-group-checkbox" }, [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "pretty p-icon p-jelly p-smooth p-curve mr-0",
                              },
                              [
                                _c("input", {
                                  staticClass: "checkbox",
                                  attrs: {
                                    id:
                                      "select-recipient-" +
                                      row.documentRequestId,
                                    type: "checkbox",
                                    "true-value": "true",
                                    name:
                                      "select-recipient-" +
                                      row.documentRequestId,
                                  },
                                  domProps: {
                                    checked: _vm.classificationIsSelected(
                                      row.documentRequestId
                                    ),
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.handleSelectClassification(
                                        row.documentRequestId
                                      )
                                    },
                                  },
                                }),
                                _vm._v(" "),
                                _c("div", { staticClass: "state p-success" }, [
                                  _c("i", { staticClass: "icon fa fa-check" }),
                                  _vm._v(" "),
                                  _c(
                                    "label",
                                    {
                                      staticClass: "hidden-text",
                                      attrs: {
                                        for:
                                          "select-recipient-" +
                                          row.documentRequestId,
                                      },
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.$t("global.words.select"))
                                      ),
                                    ]
                                  ),
                                ]),
                              ]
                            ),
                          ]),
                        ]
                      },
                    },
                    {
                      key: "classification",
                      fn: function (ref) {
                        var row = ref.row
                        return [
                          _c(
                            "h6",
                            {
                              staticClass:
                                "regular my-auto text-primary text-capitalize bold",
                            },
                            [
                              _vm._v(
                                "\n        " +
                                  _vm._s(row.classification) +
                                  "\n      "
                              ),
                            ]
                          ),
                        ]
                      },
                    },
                    {
                      key: "description",
                      fn: function (ref) {
                        var row = ref.row
                        return [
                          _c("h5", { staticClass: "mb-0 font-sm text-gray" }, [
                            row.description
                              ? _c("span", [
                                  _vm._v(
                                    "\n          " +
                                      _vm._s(
                                        _vm._f("truncateText")(
                                          row.description,
                                          50
                                        )
                                      ) +
                                      "\n        "
                                  ),
                                ])
                              : _c("span", { staticClass: "oblique" }, [
                                  _vm._v(
                                    "\n          " +
                                      _vm._s(
                                        _vm.$t(
                                          "request-package.requestDocuments.noDescription"
                                        )
                                      ) +
                                      "\n        "
                                  ),
                                ]),
                          ]),
                        ]
                      },
                    },
                    {
                      key: "applicants",
                      fn: function (ref) {
                        var row = ref.row
                        return [
                          _c(
                            "material-input",
                            [
                              _c("applicant-select", {
                                attrs: {
                                  id:
                                    "applicant-select-" + row.documentRequestId,
                                  value:
                                    _vm.selectedApplicants[
                                      row.documentRequestId
                                    ],
                                  "force-include-main-applicant": "",
                                },
                                on: {
                                  change: function (applicants) {
                                    return _vm.handleChangeSelectedApplicants(
                                      applicants,
                                      row.documentRequestId
                                    )
                                  },
                                },
                              }),
                            ],
                            1
                          ),
                        ]
                      },
                    },
                  ],
                  null,
                  false,
                  3254021365
                ),
              })
            : _c(
                "div",
                { staticClass: "d-flex flex-column align-items-center" },
                [
                  _c(
                    "no-results",
                    {
                      attrs: {
                        "img-src": require("@Shared/@Assets/img/application-missing.png"),
                      },
                    },
                    [
                      _vm._v(
                        "\n      " +
                          _vm._s(
                            _vm.$t(
                              "request-package.requestDocuments.emptyDocumentsClassification.short"
                            )
                          ) +
                          "\n      "
                      ),
                      _c("br"),
                      _vm._v(
                        "\n      " +
                          _vm._s(
                            _vm.$t(
                              "request-package.requestDocuments.emptyDocumentsClassification.segmented.0"
                            )
                          ) +
                          "\n      "
                      ),
                      _c(
                        "a",
                        {
                          staticClass: "clickable text-primary",
                          on: { click: _vm.handleRedirectClick },
                        },
                        [
                          _vm._v(
                            "\n        " +
                              _vm._s(
                                _vm.$t(
                                  "request-package.requestDocuments.emptyDocumentsClassification.segmented.1"
                                )
                              ) +
                              "\n      "
                          ),
                        ]
                      ),
                      _vm._v(
                        "\n      " +
                          _vm._s(
                            _vm.$t(
                              "request-package.requestDocuments.emptyDocumentsClassification.segmented.2"
                            )
                          ) +
                          "\n    "
                      ),
                    ]
                  ),
                ],
                1
              ),
        ],
        1
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }